import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const RequestsPerOriginChart = ({ title, data }) => {
  // Filter and transform data for display
  const transformedData = data
    .filter(item => ["oeccbb", "unitedassociates"].includes(item.origin))
    .map(item => ({
      ...item,
      origin: item.origin === "oeccbb" ? "OECCBB" : "United Associates",
      fill: item.origin === "oeccbb" ? "#18a0fb" : "#ff6384"
    }));

  return (
    <div>
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={transformedData}
          margin={{ top: 20, right: 30, left: -20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="origin" />
          <YAxis />
          <Tooltip />
          <Bar 
            dataKey="count" 
            barSize={80} 
            fill="#18a0fb"
            fillOpacity={0.8}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RequestsPerOriginChart;
